// extracted by mini-css-extract-plugin
export var button = "button-module--button--77797";
export var buttonFlex = "button-module--buttonFlex--6a518";
export var buttonInner = "button-module--buttonInner--744a2";
export var buttonJazzoo = "button-module--buttonJazzoo--e0220";
export var buttonLarge = "button-module--buttonLarge--2d95a";
export var buttonMedium = "button-module--buttonMedium--be2f1";
export var buttonSmall = "button-module--buttonSmall--c28c0";
export var buttonSmallLongText = "button-module--buttonSmallLongText--4e7a5";
export var iconMap = "button-module--iconMap--101a0";